let ProjectData=[
    {
        project_id:1,
        name: "Find Offline Mobile 1.O",
        desc: "Android application to find mobile when mobile data is off",
        image:"/Assets/find-mobile.png",
        link:"https://github.com/71203mayank/Codeinit"
    },
    {
        project_id:2,
        name:"YNotes",
        desc:"YouTube embedded note taking web application",
        image:"/Assets/ynotes.png",
        link:"https://github.com/71203mayank/YNotes"
    },
    {
        project_id:3,
        name:"Mausam.com",
        desc:"Weather forcast web application",
        image:"/Assets/mausam_com.png",
        link:"https://github.com/71203mayank/Mausam_com"
    },
    {
        project_id:4 ,
        name:"Chatter",
        desc:"Chatbot built by my team and I during a Hackathon",
        image:"/Assets/chatter.png",
        link:"https://github.com/71203mayank/Chatter"
    },
    {
        project_id: 5,
        name:"Lost & Found",
        desc:"Web application helps to report lost & found cases",
        image:"/Assets/lost-found.png",
        link:"https://github.com/71203mayank/Codeinit"
    }
]

export default ProjectData;
